import { render, staticRenderFns } from "./TableCellChips.vue?vue&type=template&id=25139a90&scoped=true"
import script from "./TableCellChips.vue?vue&type=script&lang=ts"
export * from "./TableCellChips.vue?vue&type=script&lang=ts"
import style0 from "./TableCellChips.vue?vue&type=style&index=0&id=25139a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25139a90",
  null
  
)

export default component.exports